/* ════════════════════════════════════════════════════════════════
   PAPAPATTES — pp-custom.js
   Paramètres du site + animations de scroll (collections)
   ════════════════════════════════════════════════════════════════ */

/* ⚙️ PARAMÈTRE UNIQUE — Afficher ou non le filtre standard des collections.
   (le filtrage par pictos reste toujours disponible)
   true  → le filtre est affiché
   false → le filtre est masqué (desktop + mobile), le tri reste disponible */
var PP_SHOW_FILTER = true;

(function () {
  /* Applique le paramètre : ajoute une classe sur <html> exploitée par papapattes.css */
  if (!PP_SHOW_FILTER) {
    document.documentElement.classList.add('pp-no-filter');
  }

  /* ── Animations de scroll ─────────────────────────────────────── */
  function scrollToEl(el, delay) {
    if (!el) return;
    setTimeout(function () {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, delay || 150);
  }

  function scrollToGrid(delay) {
    /* PAPAPATTES 08/09 (retour Sid, v4) : on cible en priorité la barre
       filtre/tri (.facets-wrapper), juste au-dessus de la grille, plutôt
       que la grille elle-même — sinon le scroll alignait la grille juste
       sous les barres sticky mais laissait "Trier par" / "Filtrer et
       trier" caché dessous. Si cette barre n'existe pas (page sans
       facettes), on retombe sur la grille comme avant. */
    var target = document.querySelector('.facets-wrapper') || document.getElementById('ProductGridContainer');
    scrollToEl(target, delay);
  }

  document.addEventListener('DOMContentLoaded', function () {
    /* Uniquement sur les pages collection */
    if (!document.getElementById('ProductGridContainer')) return;

    var params = new URLSearchParams(window.location.search);
    var filtered = false;
    params.forEach(function (v, k) {
      if (k.indexOf('filter.') === 0 || k === 'sort_by') filtered = true;
    });

    if (filtered) {
      /* Arrivée avec un filtre (picto / filtre / tri) → scroll vers la barre filtre/tri + 1re ligne de produits */
      scrollToGrid(250);
    } else {
      /* Arrivée sur une collection / sélection → scroll vers le filtrage par pictos */
      scrollToEl(document.querySelector('.cat-pills'), 250);
    }

    /* Filtre ou tri appliqué en AJAX (facets Dawn) → scroll vers les produits */
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('facet-filters-form')) {
        scrollToGrid(450);
      }
    });
  });

  /* PAPAPATTES 08/09 (retour Sid, v3) : au tap sur un item du sous-menu
     mobile (Chien/Chat), on le colore immediatement (classe .pp-tapped,
     stylee dans papapattes.css) et ça reste ainsi jusqu'à la navigation
     — un simple :active CSS ne "tient" pas assez longtemps sur mobile
     (relâché dès la fin du tap, avant même la navigation). */
  document.addEventListener('click', function (e) {
    var item = e.target.closest && e.target.closest('.menu-drawer__submenu .menu-drawer__menu-item');
    if (item) {
      item.classList.add('pp-tapped');
    }
  });
})();
